(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["torna-indietro"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-torna-indietro]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var da = document.referrer;
      var vietata = new RegExp('^' + window.location.origin.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '/(cart|checkout|account|orders)(/|$|\\?)').test(da);
      if (da && da.indexOf(window.location.origin) === 0 && !vietata && history.length > 1) {
        e.preventDefault();
        history.back();
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
